import * as format from '../data/format';


export function preRender(data, options) {
  const tooltip = data.tooltip = { enabled: options.interactive };
  if (tooltip.enabled) {
    tooltip.borderWidth = 1;
    tooltip.borderColor = '#CCC';
    tooltip.shared = false;
    tooltip.style = getStyle(options);
    tooltip.shadow = false;
    tooltip.formatter = function () {
      return formatter(data, options, this);
    };
  }

  if (__WSJ__) {
    if (options.product === 'wsj') {
      tooltip.borderRadius = 0;
      tooltip.padding = 4;
    }
  }
  return data;
}

function formatter(data, options, context) {
  const value = format.applyFull(context.point.y, options.tooltips, options.type === 'pie', true, true);
  const categories = options.longCategories || (options.categories ?
    options.categories[0] : null);
  const dataPoint = getDataPoint(data.series, context);
  let category;
  if (options.type === 'pie' && options.optimizeDataOrder && dataPoint.point.hasOwnProperty('originalIndex')) {
    category = context.point.name
  } else {
    category = categories ? categories[dataPoint.index] : (context.point.category ||
      context.point.options.name);
  }
  // console.log(context.point);
  // if (categories) {
  //   if (options.type === 'pie' && options.optimizeDataOrder && dataPoint.point.hasOwnProperty('originalIndex')) {
  //     category = categories[dataPoint.point.originalIndex];
  //   } else {
  //     category = categories[dataPoint.index];
  //   }
  // } else {
  //   category = context.point.category || context.point.options.name;
  // }
  const formatter = { index: dataPoint.index, category, value };

  if ((options.type === 'column' || options.type === 'area')
      && options.stacking === 'percent') {
    return formatStackedPercent(data, options, context, formatter);
  }
  return formatStandard(options, context, formatter);
}

function getDataPoint(series, context) {
  if (context.x !== undefined) {
    for (let s = 0; s < series.length; s++) {
      for (let d = 0; d < series[s].data.length; d++) {
        if (series[s].data[d].x === context.x) {
          return { point: series[s].data[d], index: series[s].data[d].index };
        }
      }
    }
  }
  return {
    point: context.point,
    index: context.point.hasOwnProperty('index') ? context.point.index :
      context.point.x
  };
}


function divideValue(value, divisorUnit) {
  if (divisorUnit && divisorUnit !== 'none') {
    const divisor = format.getDivisor(divisorUnit);
    return +value / divisor;
  }
  return value;
}

function space() {
  return '<span style="color: rgba(255, 255, 255, 0);">x</span>';
}


function formatStandard(options, context, formatter) {
  return [
    '<span>',
      formatSeries(options, context),
      '<span>',
        formatter.category,
      '</span>',
      space(),
      '<span style="font-weight: 600;">',
        formatter.value,
      '</span>',
    '</span>'
  ].join('');
}


function formatStackedPercent(data, options, context, formatter) {
  let total = 0;
  data.series.forEach(item => {
    total += item.data[formatter.index].y;
  });
  return [
    '<span style="',
    formatter.style,
    '">',
      formatSeries(options, context),
      '<span style="padding: 0 6px 0 0;">',
        formatter.category,
      '</span>',
      space(),
      '<span style="font-weight: 600; margin: 0 0 0 24px">',
        formatter.value,
        ' (',
        Math.round(context.point.y / total * 100),
        '%)',
      '</span>',
    '</span>'
  ].join('');
}



function formatSeries(options, context) {
  if (options.legend.enabled && options.series.length > 1) {
    let css;
    let defaultCSS = [
      'padding: 0 6px 0 0;',
    ];

    if (options.product !== 'wsj') {
      css = defaultCSS.concat([
        'font-weight: 600;',
        `color: ${context.series.color};`
      ]).join('');
    }

    if (options.product === 'wsj') {
      css = defaultCSS.concat([
        'font-weight: 500;'
      ]).join('');
    }

    return [
      `<span style="${css}">`,
      context.series.name,
      '</span>',
      space()
    ].join('');
  }
}


function getStyle(options) {
  let data = {
    padding: '8px',
    width: '400px',
    fontSize: '14px',
    fontFamily: options.styles.font.normal,
    fontWeight: options.styles.weight.normal,
    fontStyle: 'normal',
    color: '#000000'
  };

  if (__WSJ__) {
    if (options.product === 'wsj') {
      data.fontSize = '12px';
      data.lineHeight = '14px';
    }
  }

  return data;
}



export function postRender(highchart, options) {
  //
}



// WEBPACK FOOTER //
// ./src/chart/inner/tooltips.js